module.exports = __webpack_public_path__ + "static/media/car-black.28f219f5.svg";